export default "__VITE_ASSET__ChL$k_TQ__"